import { BaseService } from "./BaseService";

export class ReservationManageService extends BaseService {
  constructor() {
    super("/reservations");
  }

  async find(query = {}) {
    try {
      const response = await this.getClient().get(
        `${this.baseUrl}/reservation-management`,
        { params: query }
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async findOne(id) {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async create(reservation) {
    try {
      const response = await this.getClient().post(
        `${this.baseUrl}/create-reservation-management`,
        reservation
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async update(id, reservation) {
    try {
      const response = await this.getClient().put(this.baseUrl, {
        ...reservation,
        id,
      });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async delete(id) {
    try {
      const response = await this.getClient().delete(`${this.baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getDuplicateReservations() {
    try {
      const response = await this.getClient().get(`${this.baseUrl}/duplicates`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async fixDuplicateReservations(reservationIds) {
    try {
      const response = await this.getClient().post(`${this.baseUrl}/fix-duplicates`, {
        reservationIds
      });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async deleteMany(ids) {
    try {
      const response = await this.getClient().post(`${this.baseUrl}/delete-many`, { ids });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
